<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt, contentAttributes } = useMessageContext();
const route = useRoute();
const { t } = useI18n();

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);

// Encaminhamento entre caixas: o aviso ganha "Ir para a conversa".
// Preferimos o atributo gravado pelo backend; mensagens antigas (sem o
// atributo) caem no fallback por texto ("Nova conversa: #N").
const forwardDisplayId = computed(() => {
  // A camada de mensagens camel-iza content_attributes; aceita os dois.
  const attr =
    contentAttributes.value?.inboxForward ||
    contentAttributes.value?.inbox_forward;
  const fromAttr = attr?.conversationDisplayId || attr?.conversation_display_id;
  if (fromAttr) return fromAttr;
  const match = String(content.value || '').match(
    /(?:Nova conversa|Conversa original):\s*#(\d+)/
  );
  return match ? Number(match[1]) : null;
});

const forwardLink = computed(() => {
  if (!forwardDisplayId.value) return null;
  return `/app/accounts/${route.params.accountId}/conversations/${forwardDisplayId.value}`;
});
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-2 py-px !rounded-full flex min-w-0 items-center gap-1"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
    <!-- Fonte pequena (mesma escala do aviso) e cor da IDV, nao azul. -->
    <router-link
      v-if="forwardLink"
      :to="forwardLink"
      class="shrink-0 inline-flex items-center gap-0.5 text-[11px] font-semibold text-[#9B2C2C] dark:text-[#F472B6] hover:underline whitespace-nowrap"
    >
      {{ t('CONVERSATION.FORWARD_ACTIVITY_LINK') }}
      <span class="i-lucide-arrow-right size-2.5" />
    </router-link>
  </BaseBubble>
</template>
